export const sizeClasses = {
  small: 'text-sm px-6 py-1.5 rounded-[10px] max-h-[32px]',
  medium: 'text-lg px-8 py-3 rounded-xl max-h-[38px]',
  large: 'text-xl px-9 py-2 rounded-xl max-h-[44px]',
};
